import { useEffect } from 'preact/hooks';
import { token, user } from './store/state';
import { loadData } from './store/actions/data.actions';
import { subscribePush } from './api/push';
import { AppRouter } from './router';
import { ToastStack } from './components/Toast';
import { ConfirmModal } from './components/Modal';
import { useTheme } from './hooks/useTheme';

export function App() {
  useTheme();

  useEffect(() => {
    if (token.value && user.value) {
      loadData();
      subscribePush();
    }
  }, []);

  return (
    <>
      <AppRouter />
      <ToastStack />
      <ConfirmModal />
    </>
  );
}
